import httpStatus from 'http-status';
import { GenericApi } from '~/api/generic-api';
import { HelpApi, HelpApiParam } from '~/api/help-api';
import { Notification } from '~/components/notification/notification';
import { FetchUtils } from '~/utils/fetch-utils';
import { Logger } from '~/utils/logger';

export class HelpFileUtils {
	/**
	 * Open the help file for a form in a popup.
	 * @param formName the name of the form
	 * @param params an object that contains the subtype of the form (if one exists)
	 */
	public static openHelpFileIfPossible(
		formName: string,
		params: HelpApiParam,
	): void {
		HelpApi.getHelpFile(formName, params)
			.then((data) => {
				if (data.status === httpStatus.NOT_FOUND) {
					Notification.error('Unable to locate help resource');
					Logger.warn(data.message);
				} else {
					window.open(GenericApi.apiServerURL + data);
				}
			})
			.catch(FetchUtils.logAndDisplayError);
	}
}
